exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".contact-divider {\r\n  margin: 3rem 0;\r\n  border-top: 1px solid #CCC;\r\n}\r\n\r\n.contact-info {\r\n\r\n}\r\n\r\n.contact-info > .dwt-logo {\r\n  width: 96px;\r\n  margin-bottom: 1rem;\r\n}\r\n\r\n.contact-info > .contact-address {\r\n  line-height: 1.5rem;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/EricChanney/Apps/nexpress-angular-site/src/app/component/customer-service/customer-service.component.css
// module id = ../../../../../src/app/component/customer-service/customer-service.component.css
// module chunks = main